export default __webpack_public_path__ + "fonts/free-and-clear.svg";